import { createFileRoute } from "@tanstack/react-router";
import OpenInNew from "~icons/material-symbols/open-in-new";
import { css } from "../../../styled-system/css";
import { getTenantContact } from "../../config";
import { getTenantSlug } from "../../libs/utils";

export const Route = createFileRoute("/company/contact")({
  component: RouteComponent,
});

function RouteComponent() {
  const contact = getTenantContact(getTenantSlug());
  return (
    <div
      className={css({
        h: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        px: { base: "20px", md: "40px" },
      })}
    >
      <section
        className={css({
          bg: "white",
          display: "flex",
          flexDirection: "column",
          gap: "6",
          p: "8",
          textAlign: "center",
          rounded: "lg",
          shadow: "sm",
        })}
      >
        <h2
          className={css({
            fontSize: "xl",
            fontWeight: "bold",
          })}
        >
          お問い合わせ
        </h2>
        <div
          className={css({
            display: "flex",
            flexDirection: "column",
            gap: "6",
          })}
        >
          {contact.manualUrl && (
            <div
              className={css({
                display: "flex",
                flexDirection: "column",
                gap: "2",
              })}
            >
              <p className={css({ fontWeight: "bold" })}>
                操作の不明点などのご参考情報
              </p>

              <a
                href={contact.manualUrl}
                target="_blank"
                rel="noreferrer"
                className={css({
                  bg: "surface.accentPrimary",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "2",
                  px: "4",
                  py: "1.5",
                  rounded: "lg",
                  mx: "auto",
                })}
              >
                <span>操作マニュアル</span>
                <OpenInNew />
              </a>
            </div>
          )}

          <div
            className={css({
              display: "flex",
              flexDirection: "column",
              gap: "2",
            })}
          >
            <p className={css({ fontWeight: "bold" })}>{contact.phoneLabel}</p>
            <p
              className={css({
                fontSize: "xl",
                fontWeight: "bold",
              })}
            >
              {contact.phone}
            </p>
            {contact.email && (
              <a
                href={`mailto:${contact.email}`}
                className={css({ color: "surface.accentPrimary" })}
              >
                {contact.email}
              </a>
            )}
            {contact.url && (
              <a
                href={contact.url}
                target="_blank"
                rel="noreferrer"
                className={css({
                  color: "surface.accentPrimary",
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "1",
                })}
              >
                <span>{contact.url}</span>
                <OpenInNew />
              </a>
            )}
          </div>
        </div>
        <div
          className={css({
            display: "flex",
            flexDirection: "column",
            gap: "1",
          })}
        >
          <p>受付時間: {contact.hours}</p>
          {contact.hoursNotes?.map((note) => (
            <p key={note}>{note}</p>
          ))}
        </div>
      </section>
    </div>
  );
}
